import { render } from "./SubunitLeaveReport.vue?vue&type=template&id=1b25deeb&scoped=true"
import script from "./SubunitLeaveReport.vue?vue&type=script&lang=js"
export * from "./SubunitLeaveReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=1b25deeb&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b25deeb"]])

export default __exports__